import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row } from 'reactstrap'
import FooterTop from './FooterTop'
import classNames from 'classnames'
import emailEnveloperGrey from '../../shared/icons/email-envelope-grey.svg'
import mobilePhone from '../../shared/icons/mobile-phone.svg'
import './Footer.scss'
import './_Footer-mobile.scss'
import { ReactComponent as TwitterIcon } from '../../shared/icons/twitter-icon.svg'
import { ReactComponent as LinkedinIcon } from '../../shared/icons/linkedin-icon.svg'
import { ReactComponent as YoutubeIcon } from '../../shared/icons/youtube-icon.svg'
import { useGate } from 'statsig-react'
import StarRatings from 'react-star-ratings'
import axios from 'axios'
import { ShoppingContext } from '../../shared/ShoppingContext'
import { mixpanelLogEvent } from '../../utils/mixpanelLogEvent'

const { PUBLIC_URL } = process.env

const Footer = ({ footerData, showTop }) => {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear())
  const [emailAddress, setEmailAddress] = useState('')
  const [reviewData, setReviewData] = useState({})
  const {
    addressLine1,
    addressLine2,
    addressLine3,
    contactEmail,
    contactNumber,
    daysOpen,
    helpTitle,
    hoursOpen,
    linkColumns,
    linkedInLink,
    slogan,
    twitterLink,
    youtubeLink,
  } = footerData
  const testGate = useGate('test_gate').value
  const { userInfo } = useContext(ShoppingContext)

  const logClickEvent = ({ eventType, metaData }) => {
    mixpanelLogEvent({
      eventType,
      userDetails: userInfo,
      metaData,
    })
  }

  const emailSignup = () => {
    //Sign the person up for emails with state.emailAddress
    console.log(`${emailAddress} has been succesfully signed up for our newsletter`)
  }

  const LinkColumns = ({ column, index }) => {
    return (
      <div
        className={classNames('single-column', {
          'aboutus-col': column.header === 'About Us',
          'ourproducts-col': column.header === 'Important Links',
        })}
        key={index}
      >
        <div className="header">{column.header}</div>
        {column.columnLinks
          .map(i => i.fields)
          .map(link =>
            link.pathlink?.startsWith('/') ? (
              <div
                className="linkWrapper"
                key={link.linkTitle}
                onClick={() =>
                  logClickEvent({
                    eventType: `Footer_Click`,
                    metaData: { linkClicked: link?.linkTitle },
                  })
                }
              >
                <Link to={link.pathlink} className="links">
                  {link.linkTitle}
                </Link>
              </div>
            ) : (
              <div
                className="linkWrapper"
                key={link.linkTitle}
                onClick={() =>
                  logClickEvent({
                    eventType: `Footer_Click`,
                    metaData: { linkClicked: link?.linkTitle },
                  })
                }
              >
                <a href={link.pathlink} className="links" target="_blank" rel="noreferrer">
                  {link.linkTitle}
                </a>
              </div>
            ),
          )}
      </div>
    )
  }

  useEffect(() => {
    const fetchGoogleReviewData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/informational/getGoogleReviewData`,
        )
        setReviewData(response.data)
      } catch (error) {
        console.error('Error fetching Google review data:', error)
      }
    }

    fetchGoogleReviewData()
  }, [])

  return (
    <>
      {showTop && <FooterTop footerData={footerData} />}
      <Container style={{ marginTop: '-0px' }} className="footer" fluid>
        <div className="mainFooterContent">
          <div className="single-column company-col">
            <div className="header">
              <img
                className="logo"
                src={`${PUBLIC_URL}/images/dealmed-logo-white.svg`}
                alt=""
                loading="lazy"
              />
              {/* white text instead of gray */}
            </div>

            <p>{slogan}</p>
            {/* <div style={{marginTop:'7px'}}>
            <p>
              {addressLine1}
              <br /> {addressLine2}
              <br /> {addressLine3}
            </p>
            </div> */}
            <div className="social-icons-container" style={{ marginTop: '30px' }}>
              <div
                className="linkWrapper"
                onClick={() =>
                  logClickEvent({ eventType: `Footer_Click`, metaData: { linkClicked: 'Twitter' } })
                }
              >
                <a href={twitterLink} className="links" target="_blank" rel="noreferrer noopener">
                  <TwitterIcon />
                </a>
              </div>
              <div
                className="linkWrapper"
                onClick={() =>
                  logClickEvent({
                    eventType: `Footer_Click`,
                    metaData: { linkClicked: 'LinkedIn' },
                  })
                }
              >
                <a href={linkedInLink} className="links" target="_blank" rel="noreferrer noopener">
                  <LinkedinIcon />
                </a>
              </div>
              <div
                className="linkWrapper"
                onClick={() =>
                  logClickEvent({ eventType: `Footer_Click`, metaData: { linkClicked: 'Youtube' } })
                }
              >
                <a href={youtubeLink} className="links" target="_blank" rel="noreferrer noopener">
                  <YoutubeIcon />
                </a>
              </div>
            </div>
          </div>
          <div className="single-column needhelp-col">
            <div className="header">{helpTitle}</div>
            {/* <p>Support</p> */}
            <p className="opening-time">
              {daysOpen}:<br />
              {hoursOpen}
            </p>
            <div className="contact-data-list">
              <p className="contact-with-icon">
                {' '}
                <img src={mobilePhone} alt="phone-icon" loading="lazy" />
                {contactNumber}
              </p>
              <p className="contact-with-icon">
                <img src={emailEnveloperGrey} alt="email-icon" loading="lazy" />
                <a href="mailto:support@dealmed.com">{contactEmail}</a>
              </p>
              <div>
                <div
                  style={{ display: 'flex', alignItems: 'flex-end', gap: '6px', marginTop: '7px' }}
                >
                  <p style={{ fontSize: '14px' }}>{reviewData.rating}</p>
                  <StarRatings
                    rating={reviewData.rating}
                    starRatedColor="white"
                    starEmptyColor="#8F9CBC"
                    starDimension="16px"
                    starSpacing="2px"
                    name="rating"
                  />
                </div>
                <a
                  href="https://www.google.com/search?q=google+reviews+for+dealmed&oq=google+reviews+for+dealmed&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIGCAEQRRhA0gEIMzQ5N2owajeoAgCwAgA&sourceid=chrome&ie=UTF-8#lrd=0x89c244a0b07dbd3b:0x8b5d75813484ea73,1,,,,"
                  className="links"
                  target="_blank"
                  rel="noreferrer noopener"
                  style={{ color: 'white' }}
                >
                  <p
                    style={{ fontSize: '14px' }}
                    onClick={() =>
                      logClickEvent({
                        eventType: `Footer_Click`,
                        metaData: { linkClicked: 'Google Reviews' },
                      })
                    }
                  >
                    {reviewData.userRatingCount} Google Reviews
                  </p>
                </a>
              </div>
            </div>
          </div>
          {linkColumns
            .map(i => i.fields)
            .map((column, index) => (
              <LinkColumns column={column} index={index} key={index} />
            ))}
        </div>
      </Container>
      {testGate && <div id="statsig-test">Test</div>}

      <Row className="footerBottom d-flex justify-content-between">
        <span>&copy; {`2008 - ${currentYear} Dealmed Medical Supplies LLC`}</span>
      </Row>
    </>
  )
}

export default Footer
